import { render, staticRenderFns } from "./shippingSvg.vue?vue&type=template&id=5bc012bc"
import script from "./shippingSvg.vue?vue&type=script&lang=js"
export * from "./shippingSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports